import { FC, useState } from 'react';
import { getAdPdf } from '@/api/queries/useAdPdf';
import { Icon } from '@/components';
import { Icons } from '@/enums';
import strings from '@/language/Swedish';
import styled from 'styled-components';

const StyledIcon = styled(Icon)`
  transform: rotate(45deg);
`;

interface Props {
  prospectUrl: string | null;
}

const AdPdfCell: FC<Props> = ({ prospectUrl }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [pdfUrl, setPdfUrl] = useState<string | null>(null);

  const handleClick = async () => {
    if (!prospectUrl || isLoading) return;

    // If we already have the URL, just open it
    if (pdfUrl) {
      window.open(pdfUrl, '_blank');
      return;
    }

    setIsLoading(true);

    try {
      const url = await getAdPdf(prospectUrl);
      setPdfUrl(url);
      // Automatically open the PDF after it's fetched
      if (url) {
        window.open(url, '_blank');
      }
    } catch {
      // Error handled silently
    } finally {
      setIsLoading(false);
    }
  };

  if (!prospectUrl) {
    return null;
  }

  if (isLoading) {
    return <span>{strings.data.loading}...</span>;
  }

  if (pdfUrl) {
    return (
      <a
        href={pdfUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="flex gap-2 items-center"
      >
        {strings.table.link}
        <StyledIcon icon={Icons.arrowUp} />
      </a>
    );
  }

  return (
    <a
      onClick={handleClick}
      style={{ cursor: 'pointer' }}
      className="flex gap-2 items-center"
    >
      {strings.table.link}
      <StyledIcon icon={Icons.arrowUp} />
    </a>
  );
};

export default AdPdfCell;